import { useEffect, useMemo, useState } from "react";
import { getImage, deepMerge } from "../_utils";

const PreviewSchema = {
  message_text: "",
  message_font_family: null,
  signature_font_family: null,
  message_salutation: null,
  amount: "",
  selected_card_image: "",
  recipient_name: "",
  expiry_date: null,
  message_from: "",
  video_thumbnail_url: "",
  issued_gift_card_code: "XXXXXXXXXXXXXXXX",
  video_hash: "",
};

/**
 * Bootstrap the initial preview data based on settings, and default form data.
 *
 * @param {Object} settings
 * @param {Object} formData
 */
const getInitialPreviewData = (formData: any, previewData: any) => {

  if (!formData) return formData;

  const newPreview = {
    message_text: typeof(formData.properties._gcp_message_text) != 'undefined' ? formData.properties._gcp_message_text : "",
    currency: typeof(window.APP_ADMIN) != 'undefined' ? window.APP_ADMIN.currency : "USD",
    selected_card_image: typeof(formData.properties._gcp_selected_card_image) != 'undefined' ? getImage(formData.properties._gcp_selected_card_image) : "", // Build the correct url
    recipient_name: typeof(formData.properties._gcp_recipient_name) != 'undefined' ? formData.properties._gcp_recipient_name : "",
    message_from: typeof(formData.properties._gcp_message_from) != 'undefined' ? formData.properties._gcp_message_from : "",
    video_thumbnail_url: typeof(formData.properties._gcp_thumbnail_image) != 'undefined' ? formData.properties._gcp_thumbnail_image : "",
    video_hash: typeof(formData.properties._gcp_video_id) != 'undefined' ? formData.properties._gcp_video_id : "",
    message_font_family: typeof(formData.properties._gcp_message_font_family) != 'undefined' ? formData.properties._gcp_message_font_family : null,
    signature_font_family: typeof(formData.properties._gcp_signature_font_family) != 'undefined' ? formData.properties._gcp_signature_font_family : null,
    message_salutation: typeof(formData.properties._gcp_message_salutation) != 'undefined' ? formData.properties._gcp_message_salutation : null,
    amount: 0,
  }

  if (formData.id == "Custom") {
    newPreview.amount = formData.properties._gcp_custom_value * 100
  }

  return deepMerge(previewData, newPreview);

};



const useGiftCardPreviewManager = ({
  formData,
  settings,
  giftCardCost,
  preview,
  fulfillmentType,
  bulkOrder
}: any) => {


  const [previewData, setPreviewData] = useState(PreviewSchema);
  const [emailPreviewData, setEmailPreviewData] = useState(PreviewSchema);

  /**
   * Update preview field value
   * @param {*} field 
   * @param {*} data 
   */
  const updatePreviewField = (field: string, data: any) => {
    const newData: any = { ...previewData };
    newData[field] = data;
    setPreviewData(newData);
  };

  useEffect(() => {
    
    if (bulkOrder === true) {
      return;
    }

    const newPreviewData = getInitialPreviewData(formData, previewData);

    setPreviewData({ ...newPreviewData });
    setEmailPreviewData({ ...newPreviewData });

  }, [formData, fulfillmentType]);

  useEffect(() => {

    if (bulkOrder === true) {
      return;
    }
    
    const newPreviewData  = getInitialPreviewData(formData, previewData);
    setPreviewData({ ...newPreviewData });
    setEmailPreviewData({ ...newPreviewData });

  }, [settings]);

  /**
   * Update the display cost for the preview
   */
  useEffect(() => {
    if (typeof giftCardCost.value === "number") {
      updatePreviewField("amount", giftCardCost.value * 100);
    }
  }, [giftCardCost.value]);

  const res = {
    previewData,
    emailPreviewData
  };

  return useMemo(() => res, [res]);

}

export default useGiftCardPreviewManager;